<template>
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="44"
		height="44"
		viewBox="0 0 44 44"
		aria-hidden="true">
		<path d="M33.5227 22C33.5227 24.4651 32.1618 26.7601 29.8352 28.4663C27.5091 30.1721 24.2592 31.25 20.6364 31.25C17.0135 31.25 13.7637 30.1721 11.4375 28.4663C9.11095 26.7601 7.75 24.4651 7.75 22C7.75 19.5349 9.11095 17.2399 11.4375 15.5337C13.7637 13.8279 17.0135 12.75 20.6364 12.75C24.2592 12.75 27.5091 13.8279 29.8352 15.5337C32.1618 17.2399 33.5227 19.5349 33.5227 22Z" fill="#E5F6FD" stroke="#0074B5" stroke-width="1.5" />
	</svg>
</template>
